import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'
import { statusTranslationKeyMap } from '../contractStatuses'

interface StatusColour {
  light: string
  dark: string
}

const statusColourMap: Record<string, StatusColour> = {
  'Données client à renseigner': { light: '#ffed78', dark: '#8b7900' },
  'Souscription web a finaliser': { light: '#ffed78', dark: '#8b7900' },
  'Données compteur a renseigner': { light: '#ffed78', dark: '#8b7900' },
  'BS complet': { light: '#C6EE55', dark: '#5B6E27' },
  'Prêt pour la transmission': { light: '#C6EE55', dark: '#5B6E27' },
  'Erreur lors du transfert': { light: '#ffd07a', dark: '#40281f' },
  'Signé avec erreur': { light: '#ffd07a', dark: '#40281f' },
  'Rétractation par le fournisseur': { light: '#FEE9E9', dark: '#DC0909' },
  'Rétractation par Selectra': { light: '#FEE9E9', dark: '#DC0909' },
  'Signé': { light: '#F1FFFF', dark: '#0C8A1E' },
  'Activé': { light: '#F1FFFF', dark: '#0C8A1E' },
  'Transféré': { light: '#00bbbb', dark: '#003434' },
}

function getStatusColour(status: string): StatusColour {
  return statusColourMap[status] ?? { light: '#c1d1e2', dark: '#565e66' }
}

interface StatusCellProps {
  status: string
}

const StatusCell = ({ status }: StatusCellProps) => {
  const [css] = useStyletron()
  const colour = getStatusColour(status)
  const { t } = useTranslation()

  const badgeStyle = css({
    display: 'flex',
    width: '100%',
    padding: '.125rem .25rem',
    border: `2px solid ${colour.light}`,
    background: colour.light,
    color: colour.dark,
    borderRadius: '.25rem',
  })
  const textStyle = css({
    margin: '0 auto',
    fontSize: '.75rem',
    textAlign: 'center',
  })

  const translationKey = statusTranslationKeyMap[status]
  const label = translationKey ? t(translationKey) : status

  return (
    <div className={badgeStyle}>
      <div className={textStyle}>{label || t('subscriptionTable:no_status')}</div>
    </div>
  )
}

export default StatusCell
